export class MaintenanceOrderNoteModel {
  maintenanceOrderNoteId: number = 0;
  consecutive: number = 0;
  maintenanceOrderId: number = 0;
  maintenanceOrderConsecutive: number = 0;
  conceptId: number = 0;
  dateMaintenanceOrderNote: Date = new Date();
  annotation: string | null = null;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
